import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qrthtbpuwu: FaireBrandEntity = {
  token: "b_qrthtbpuwu",
  type: "brand",
  name: "Funkyrel® Atzbranding Limited",
  avatarUrl:
    "https://cdn.faire.com/fastly/a360dc4f7990bb390bd6ba6ae559411ba52a186d489ee66b1a1d1a8b7f6a93ae.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cef87d242bbde347cd268e1bcc97cef2cda182ff735c21b67c5ddbe9b20a1e7e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a360dc4f7990bb390bd6ba6ae559411ba52a186d489ee66b1a1d1a8b7f6a93ae.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cef87d242bbde347cd268e1bcc97cef2cda182ff735c21b67c5ddbe9b20a1e7e.png",
  location: "New City, NY, USA",
  minimumOrderDollars: 69,
  rating: 4.8,
  reviewCount: 821,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Funkyrel, where style meets playfulness in our handcrafted, colorful accessories! \n\nAs a part of Atzbranding Limited, we are all about celebrating individuality and adding a pop of funk to your everyday look. With fun prints and quality fabrics, our bright and cheerful accessories are the perfect way to accessorize your unique style. From chic headbands to eye-catching bracelets, let Funkyrel be your go-to brand for fashion-forward fun! Embrace the vibrancy and let your personality shine through our delightful creations. \n\nGet ready to stand out and make a statement with Funkyrel's fashionably fun accessories!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:54.962Z",
    importedBy: "entity-db-cli",
  },
};
